<template>
  <el-dialog title="帮助" v-model="visible" width="1100px">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="1.如何重置密码、账号解锁？" name="1">
        <p>● 设立单位账号：反馈至上级卫健委</p>
        <p>● 实验室账号：由设立单位账号操作</p>
        <p class="indent">点击“管理后台”模块，在左侧点击系统管理-权限管理-用户管理，在搜索栏模糊搜索单位名称，找到单位后点击单位名称，查看该单位下的单位和实验室账号，给对应的账号点击【启用】则解锁该账号，点击【密码】则可以重置密码。</p>
        <img src="@/assets/images/help/help1.png">
        <img src="@/assets/images/help/help2.png">
      </el-collapse-item>
      <el-collapse-item title="2.使用国家平台备案的省份，如何获得账号？" name="2">
        <p>● 各级卫健委账号：由国家卫生健康委统一发放</p>
        <p>● 设立单位账号：系统注册后获得单位账号</p>
        <p>● 实验室账号：设立单位在“备案系统”模块，“管理实验室”栏目下创建</p>
      </el-collapse-item>
      <el-collapse-item title="3.在省平台已备案的实验室，如何获取国家平台账号？" name="3">
        <p>实验室在省级平台完成备案后，实验室及设立单位相关信息会自动推送至国家平台并自动创建国家平台账号，用户可直接获取且无需重复填报实验室基础信息。</p>
        <p>通过省级平台备案，再将数据推送至国家平台的省份有：</p>
        <p>浙江省、新疆维吾尔族自治区、江西省、山东省、北京市、广东省、湖北省、江苏省、安徽省、山西省、陕西省、上海市、黑龙江省。</p>
        <p>具体获取方法如下：</p>
        <p>3.1获取设立单位账号：</p>
        <p>● 登录国家病原微生物实验室管理服务平台，点击【注册账户】</p>
        <p>● 填写所属区域、单位统一信用代码，点击【下一步】</p>
        <p>● 补全本单位实验室管理部门负责人、负责人手机号，点击【下一步】</p>
        <p>● 填写账号、密码、二次确认密码</p>
        <p>● 点击【注册完成】，完成单位账号创建</p>
        <img src="@/assets/images/help/help3.png">
        <p>3.2获得实验室账号：</p>
        <p>● 设立单位登录国家病原微生物实验室管理服务平台</p>
        <p>● 点击“实验室备案管理系统”，点击左侧“管理实验室”菜单，进入管理实验室界面</p>
        <p>● 列表实验室账号显示实验室登录用户名，点击【重置密码】，完成实验室密码重置</p>
        <p>● 点击【复制】，用新密码登录实验室账号</p>
        <img src="@/assets/images/help/help4.png">
      </el-collapse-item>
      <el-collapse-item title="4.设立单位注册后，登录提示账号或密码错误？" name="4">
        <p class="indent">设立单位注册完成后，账号名称后默认需要加@省份，例如云南省要加@yn</p>
      </el-collapse-item>
    </el-collapse>
  </el-dialog>
</template>

<script setup>
import { ref } from "vue";

const visible=ref(false);
const activeNames=ref([]);

function open(){
  visible.value=true;
}

defineExpose({open});
</script>

<style lang="scss" scoped>
p{
  font-size: 14px;
}

.indent{
  text-indent: 2em;
}

img{
  width: 1000px;
}
</style>